interface Detect {
    showAgent: () => void;
    addClass: () => any;
}
declare global {
    interface Window {
        ActiveXObject: any;
    }
}
const detect: Detect = {
    showAgent: () => {
        console.log(window.navigator.userAgent);
    },
    addClass: () => {

        const userAgent: string = window.navigator.userAgent;
        if (userAgent.includes('Edge')) {
            return { Edge: true };
        } else if (userAgent.includes('Firefox')) {
            return { Firefox: true };
        } else if (userAgent.includes('Chrome')) {
            return { Chrome: true };
        } else if (!!window.ActiveXObject || "ActiveXObject" in window) {
            return { ie11: true };
        } else {
            return {};
        }
    }
};


export default detect;
